type GetItemOptions = {
  once?: boolean;
};

const sessionStorage: Record<string, string | undefined> = {};

/**
 * Récupère un élément du localStorage avec fallback sur sessionStorage
 * @param key - Clé de l'élément à récupérer
 * @param options - Options de récupération (once: supprime après lecture)
 * @returns La valeur stockée ou undefined
 */
export const getItemFromStorage = (
  key: string,
  options: GetItemOptions = {}
): string | undefined => {
  let value: string | undefined;

  try {
    value = localStorage.getItem(key) ?? undefined;
  } catch (_error) {
    value = sessionStorage[key];
  }

  if (options.once && value !== undefined) {
    removeItemFromStorage(key);
  }

  return value;
};

/**
 * Stocke un élément dans le localStorage avec fallback sur sessionStorage
 * @param key - Clé de stockage
 * @param value - Valeur à stocker
 */
export const setItemToStorage = (key: string, value: string): void => {
  try {
    localStorage.setItem(key, value);
  } catch (_error) {
    sessionStorage[key] = value;
  }
};

/**
 * Supprime un élément du localStorage avec fallback sur sessionStorage
 * @param key - Clé de l'élément à supprimer
 */
export const removeItemFromStorage = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch (_error) {
    delete sessionStorage[key];
  }
};
